var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("What are you doing?!")]),_c('h2',[_vm._v("You really shouldn't be here...")])])
}]

export { render, staticRenderFns }